import { environment } from '../../../environments/environment';
import { ITokenData } from '../interfaces/wallet.interface';

export const tokenList: ITokenData[] = [] as ITokenData[];

export const nativeList: ITokenData[] = [
  {
    name: 'Ethereum',
    symbol: 'ETH',
    category: 'ETH',
    chainId: environment.eth.chainIdInt,
    image: '/assets/images/svg-icons/eth_drop.svg',
    tokenBalance: 0,
    tokenUsdVal: 0,
    desCount: 10,
  },
  {
    name: 'Tether USD',
    symbol: 'USDT',
    category: 'ETH',
    chainId: environment.eth.chainIdInt,
    image: '/assets/images/svg-icons/eth_usdt_dropdown.svg',
    tokenBalance: 0,
    tokenUsdVal: 0,
    desCount: 4,
  },
  {
    name: 'USD Coin',
    symbol: 'USDC',
    category: 'ETH',
    chainId: environment.eth.chainIdInt,
    image: '/assets/images/svg-icons/usdc_eth.svg',
    tokenBalance: 0,
    tokenUsdVal: 0,
    desCount: 4,
  },
  {
    name: 'Binance Coin',
    symbol: 'BNB',
    category: 'BNB',
    chainId: environment.bsc.chainIdInt,
    image: '/assets/images/svg-icons/bnb-with-bnb.svg',
    tokenBalance: 0,
    tokenUsdVal: 0,
    desCount: 6,
  },
  {
    name: 'Tether USD',
    symbol: 'USDT',
    category: 'BNB',
    chainId: environment.bsc.chainIdInt,
    image: '/assets/images/svg-icons/usdt-with-bnb.svg',
    tokenBalance: 0,
    tokenUsdVal: 0,
    desCount: 4,
  },
  {
    name: 'USD Coin',
    symbol: 'USDC',
    category: 'BNB',
    chainId: environment.bsc.chainIdInt,
    image: '/assets/images/svg-icons/usdc_bsc.svg',
    tokenBalance: 0,
    tokenUsdVal: 0,
    desCount: 4,
  },
  {
    name: 'SOL',
    symbol: 'SOL',
    category: 'SOL',
    chainId: environment.sol.chainIdInt,
    image: '/assets/images/svg-icons/sol_sol.svg',
    tokenBalance: 0,
    tokenUsdVal: 0,
    desCount: 6,
    otherSymbol: "Solana"
  },
  {
    name: 'USDT Coin',
    symbol: 'USDT',
    category: 'SOL',
    chainId: environment.sol.chainIdInt,
    image: '/assets/images/svg-icons/usdt_sol.svg',
    tokenBalance: 0,
    tokenUsdVal: 0,
    desCount: 4,
  },
  {
    name: 'USD Coin',
    symbol: 'USDC',
    category: 'SOL',
    chainId: environment.sol.chainIdInt,
    image: '/assets/images/svg-icons/usdc_sol.svg',
    tokenBalance: 0,
    tokenUsdVal: 0,
    desCount: 4,
  },
];
